import {
  Grid,
  List,
  Paper,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useEffect, useState } from "react";
import { Warning as WarningIcon } from "../../../../applicants/Components/Icon";
import service from "../../../Helpers/gifservices";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { forwardRef } from "react";
import ProgressGroup from "./ProgressGroup";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "40%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `10%`,
    left: `35%`,
    height: "75%",
    overflow:"scroll",
  },
  title: {
    fontSize: 18,
    fontWeight: 500,
    marginLeft: 10,
    marginRight: 10,
  },
}));


const Progress = (props, ref) => {
  const classes = useStyles();
  const [hasErrors, setHasErrors] = useState(null);
  const [submitValidation, setSubmitValidation] = useState(null);
  const [proposalApplicants, setProposalApplicants] = useState(null);
  const { proposalId, ...rest } = props;
  const getStatus = useCallback(async () => {
    const submitStatus = await service.getSubmitStatus({ proposalId });
    const proposalApplicants = await service.getProposalsApplicants({
      proposalId,
    });
    setSubmitValidation(submitStatus);
    setProposalApplicants(proposalApplicants);
  }, [proposalId]);

  useEffect(() => {
    if (submitValidation && proposalApplicants) {
      submitValidation.proposalData.validations.forEach(
        (v) => !v.isValid && setHasErrors(true)
      );
      submitValidation.applicantsData.forEach((applicant) =>
        applicant.validations.forEach((v) => !v.isValid && setHasErrors(true))
      );
    }
  }, [submitValidation, proposalApplicants]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);


  const ErrorsContent = () => (
    <>
      <Grid container>
        <WarningIcon />
        <Typography className={classes.title}>
          Proposal Missing Information:
        </Typography>
      </Grid>
      <List>
         <ProgressGroup group={submitValidation.proposalData} applicants={proposalApplicants}/>
              {submitValidation.applicantsData.map((group) => (
                <ProgressGroup key={group.id} group={group} applicants={proposalApplicants}/>
              ))}
      </List>
    </>
  );

  const NoErrorsContent = () => (
    <Grid container>
      <Typography className={classes.title}>Proposal Completed!</Typography>
      <DoneAllIcon />
    </Grid>
  );

  const LoadingContent = () => (
    <Grid container>
      <Typography className={classes.title}>Working on it....</Typography>
    </Grid>
  );

  const content = () => {
    if (hasErrors === null) return LoadingContent();
    if (hasErrors === true) return ErrorsContent();
    return NoErrorsContent();
  };

  return (
    <Paper ref={ref} {...rest} elevation={3} className={classes.paper}>
      {content()}
    </Paper>
  );
};
export default forwardRef(Progress);
